import ArrowPuzzle from './arrow-puzzle.webp'
import ArrowPuzzleFod from './arrow-puzzle_fod.webp'
import BreakALuckyEggBrainrots from './break-a-lucky-egg-brainrots.webp'
import BreakALuckyEggBrainrotsFod from './break-a-lucky-egg-brainrots_fod.webp'
import BubblePopLegend from './bubble-pop-legend.webp'
import BubblePopLegendFod from './bubble-pop-legend_fod.webp'
import ElementalMonstersMerge from './elemental-monsters-merge.webp'
import ElementalMonstersMergeFod from './elemental-monsters-merge_fod.webp'
import FindTheFrogHiddenObjects from './find-the-frog--hidden-objects.webp'
import FindTheFrogHiddenObjectsFod from './find-the-frog--hidden-objects_fod.webp'
import GoodSortMaster from './good-sort-master.webp'
import GoodSortMasterFod from './good-sort-master_fod.webp'
import Hedgies from './hedgies.webp'
import HedgiesFod from './hedgies_fod.webp'
import HiddenObjectMyHotel from './hidden-object-my-hotel.webp'
import HiddenObjectMyHotelFod from './hidden-object-my-hotel_fod.webp'
import HiddenObjectStreetOfSecrets from './hidden-object-street-of-secrets.webp'
import HiddenObjectStreetOfSecretsFod from './hidden-object-street-of-secrets_fod.webp'
import IdolLivestreamDollDressUp from './idol-livestream-doll-dress-up.webp'
import IdolLivestreamDollDressUpFod from './idol-livestream-doll-dress-up_fod.webp'
import MahjongClassic from './mahjong-classic.webp'
import MahjongClassicFod from './mahjong-classic_fod.webp'
import MasterChess from './master-chess.webp'
import MasterChessFod from './master-chess_fod.webp'
import MergeFight from './merge--fight.webp'
import MergeFightFod from './merge--fight_fod.webp'
import MillionaireLife from './millionaire-life.webp'
import MillionaireLifeFod from './millionaire-life_fod.webp'
import MyTownHomeFamilyPlayhouse from './my-town-home-family-playhouse.webp'
import MyTownHomeFamilyPlayhouseFod from './my-town-home-family-playhouse_fod.webp'
import NutsPuzzleSortByColor from './nuts-puzzle-sort-by-color.webp'
import NutsPuzzleSortByColorFod from './nuts-puzzle-sort-by-color_fod.webp'
import PieceOfCakeMergeBake from './piece-of-cake-merge--bake.webp'
import PieceOfCakeMergeBakeFod from './piece-of-cake-merge--bake_fod.webp'
import PlantsVsZombiesFusionEdition from './plants-vs-zombies-fusion-edition.webp'
import PlantsVsZombiesFusionEditionFod from './plants-vs-zombies-fusion-edition_fod.webp'
import PregnantMotherSimulator from './pregnant-mother-simulator.webp'
import PregnantMotherSimulatorFod from './pregnant-mother-simulator_fod.webp'
import RobbyDoubleJumpForBrainrots from './robby-double-jump-for-brainrots.webp'
import RobbyDoubleJumpForBrainrotsFod from './robby-double-jump-for-brainrots_fod.webp'
import TbWorld from './tb-world.webp'
import TbWorldFod from './tb-world_fod.webp'
import WordFinder from './word-finder.webp'
import WordFinderFod from './word-finder_fod.webp'

export const topPlaygamaIcons: Record<string, string> = {
    'arrow-puzzle': ArrowPuzzle,
    'arrow-puzzle_fod': ArrowPuzzleFod,
    'break-a-lucky-egg-brainrots': BreakALuckyEggBrainrots,
    'break-a-lucky-egg-brainrots_fod': BreakALuckyEggBrainrotsFod,
    'bubble-pop-legend': BubblePopLegend,
    'bubble-pop-legend_fod': BubblePopLegendFod,
    'elemental-monsters-merge': ElementalMonstersMerge,
    'elemental-monsters-merge_fod': ElementalMonstersMergeFod,
    'find-the-frog--hidden-objects': FindTheFrogHiddenObjects,
    'find-the-frog--hidden-objects_fod': FindTheFrogHiddenObjectsFod,
    'good-sort-master': GoodSortMaster,
    'good-sort-master_fod': GoodSortMasterFod,
    hedgies: Hedgies,
    hedgies_fod: HedgiesFod,
    'hidden-object-my-hotel': HiddenObjectMyHotel,
    'hidden-object-my-hotel_fod': HiddenObjectMyHotelFod,
    'hidden-object-street-of-secrets': HiddenObjectStreetOfSecrets,
    'hidden-object-street-of-secrets_fod': HiddenObjectStreetOfSecretsFod,
    'idol-livestream-doll-dress-up': IdolLivestreamDollDressUp,
    'idol-livestream-doll-dress-up_fod': IdolLivestreamDollDressUpFod,
    'mahjong-classic': MahjongClassic,
    'mahjong-classic_fod': MahjongClassicFod,
    'master-chess': MasterChess,
    'master-chess_fod': MasterChessFod,
    'merge--fight': MergeFight,
    'merge--fight_fod': MergeFightFod,
    'millionaire-life': MillionaireLife,
    'millionaire-life_fod': MillionaireLifeFod,
    'my-town-home-family-playhouse': MyTownHomeFamilyPlayhouse,
    'my-town-home-family-playhouse_fod': MyTownHomeFamilyPlayhouseFod,
    'nuts-puzzle-sort-by-color': NutsPuzzleSortByColor,
    'nuts-puzzle-sort-by-color_fod': NutsPuzzleSortByColorFod,
    'piece-of-cake-merge--bake': PieceOfCakeMergeBake,
    'piece-of-cake-merge--bake_fod': PieceOfCakeMergeBakeFod,
    'plants-vs-zombies-fusion-edition': PlantsVsZombiesFusionEdition,
    'plants-vs-zombies-fusion-edition_fod': PlantsVsZombiesFusionEditionFod,
    'pregnant-mother-simulator': PregnantMotherSimulator,
    'pregnant-mother-simulator_fod': PregnantMotherSimulatorFod,
    'robby-double-jump-for-brainrots': RobbyDoubleJumpForBrainrots,
    'robby-double-jump-for-brainrots_fod': RobbyDoubleJumpForBrainrotsFod,
    'tb-world': TbWorld,
    'tb-world_fod': TbWorldFod,
    'word-finder': WordFinder,
    'word-finder_fod': WordFinderFod,
}
